import { combineReducers } from 'redux';
import orderReducer from './orderReducer';
import designReducer from './designReducer';
import loginReducer from './loginReducer';

const rootReducer = combineReducers({
    storeSettingData : designReducer,
    orderDataDetails  : orderReducer,
    login  : loginReducer 
});

export default rootReducer;




// WEBPACK FOOTER //
// ./src/redux/reducers/index.js